var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from "@fluentui/react";
import { appConfigs } from "../../utils/appConfigs";
import { Theme, useTheme } from "../../utils/useTheme";
export var Branding = function (props) {
    var theme = useTheme();
    return _jsx(Image, __assign({ src: theme.current === Theme.LIGHT ? appConfigs.branding.logoLightUrl : appConfigs.branding.logoDarkUrl, alt: "Brand logo", height: 54 }, props), void 0);
};
//# sourceMappingURL=Branding.js.map